import AppCardTabListContainer from '@nxsys/components/AppCardTabListContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Typography } from 'antd';
import { useMemo, useState } from 'react';
import Vehicle from './components/BIK/Vehicle';
import Loan from './components/BIK/Loan';
import Accommodation from './components/BIK/Accommodation';
import MedicalInsurance from './components/BIK/MedicalInsurance';
import ShareBasedRemuneration from './components/BIK/ShareBasedRemuneration';
import AnnualBenefit from './components/BIK/AnnualBenefit';
import OneOffBenefit from './components/BIK/OneOffBenefit';

type Props = {
  employeeId: string;
};

enum BIK_TAB {
  VEHICLE = 'VEHICLE',
  LOAN = 'LOAN',
  ACCOMMODATION = 'ACCOMMODATION',
  MEDICAL_INSURANCE = 'MEDICAL_INSURANCE',
  SHARE_BASED_REMUNERATION = 'SHARE_BASED_REMUNERATION',
  ANNUAL_BENEFIT = 'ANNUAL_BENEFIT',
  ONE_OFF_BENEFIT = 'ONE_OFF_BENEFIT',
}

const BIKListing = ({ employeeId }: Props) => {
  const { messages } = useTypedIntl();

  const tabs = useMemo(
    () => [
      {
        tab: messages['common.vehicle'],
        key: BIK_TAB.VEHICLE,
      },
      {
        tab: messages['common.loan'],
        key: BIK_TAB.LOAN,
      },
      {
        tab: messages['common.accommodation'],
        key: BIK_TAB.ACCOMMODATION,
      },
      {
        tab: messages['common.medicalInsurance'],
        key: BIK_TAB.MEDICAL_INSURANCE,
      },
      {
        tab: messages['common.shareBasedRemuneration'],
        key: BIK_TAB.SHARE_BASED_REMUNERATION,
      },
      {
        tab: messages['common.annualBenefit'],
        key: BIK_TAB.ANNUAL_BENEFIT,
      },
      {
        tab: messages['common.oneOffBenefit'],
        key: BIK_TAB.ONE_OFF_BENEFIT,
      },
    ],
    [],
  );

  const [activeTab, setActiveTab] = useState<BIK_TAB>(BIK_TAB.VEHICLE);

  const handleTabChange = (key: BIK_TAB) => {
    setActiveTab(key);
  };

  const renderTabContent = (key: BIK_TAB) => {
    switch (key) {
      case BIK_TAB.VEHICLE:
        return <Vehicle employeeId={employeeId} />;
      case BIK_TAB.LOAN:
        return <Loan employeeId={employeeId} />;
      case BIK_TAB.ACCOMMODATION:
        return <Accommodation employeeId={employeeId} />;
      case BIK_TAB.MEDICAL_INSURANCE:
        return <MedicalInsurance employeeId={employeeId} />;
      case BIK_TAB.SHARE_BASED_REMUNERATION:
        return <ShareBasedRemuneration employeeId={employeeId} />;
      case BIK_TAB.ANNUAL_BENEFIT:
        return <AnnualBenefit employeeId={employeeId} />;
      case BIK_TAB.ONE_OFF_BENEFIT:
        return <OneOffBenefit employeeId={employeeId} />;
      default:
        return <></>;
    }
  };

  return (
    <div>
      <Typography.Title
        level={5}
        className="!mb-6 !text-[20px] !leading-[1.6] !tracking-[-0.02em] !text-[#1A1D1F]"
      >
        {messages['common.benefitInKind']}
      </Typography.Title>
      <AppCardTabListContainer
        tabList={tabs}
        activeTab={activeTab}
        handleTabChange={handleTabChange}
        className="!border-none"
      >
        <div className="pt-4">{renderTabContent(activeTab)}</div>
      </AppCardTabListContainer>
    </div>
  );
};

export default BIKListing;
